import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as styles from "./Tab.css.js";
// An underlined tab (trip detail view). Active tab gets full-brightness text and a 2px
// amber underline; optional leading icon and trailing count pill.
export const Tab = ({ children, active = false, icon, count, onClick }) => {
    const onKeyDown = (e) => {
        if (onClick !== undefined && (e.key === "Enter" || e.key === " ")) {
            e.preventDefault();
            onClick();
        }
    };
    return (_jsxs("div", { className: styles.tab, "data-active": active, role: "tab", "aria-selected": active, tabIndex: 0, onClick: onClick, onKeyDown: onKeyDown, children: [icon, _jsx("span", { children: children }), count !== undefined && count !== null && _jsx("span", { className: styles.count, children: count })] }));
};
//# sourceMappingURL=Tab.js.map